import axios from 'axios';
import queryString from 'query-string';

const getDocuments = ({ companyId, path }) =>
  axios.post('/advisors/get_documents', {
    company_id: companyId,
    path,
  });
const listAllUserEmails = () => axios.get('/advisors/list_all_emails');
const getToDoList = ({ reset }) =>
  axios.get(`/advisors/get_to_do_list?reset=${reset}`);
const dismissToDoItem = id =>
  axios.get(`/advisors/dismiss_to_do_item?id=${id}`);
const getQuestionnaires = ({ ids }) =>
  axios.post('/advisors/get_questionnaires', {
    ids,
  });
const getComments = ({ ids }) =>
  axios.post('/advisors/get_comments', {
    ids,
  });
const getMessages = ({ ids }) =>
  axios.post('/advisors/get_messages', {
    ids,
  });
const getAllQuestionnaireYears = () =>
  axios.get('/advisors/get_all_questionnaire_years');
const renameItem = ({ itemName, newName, path, companyId }) =>
  axios.post('/advisors/rename_item', {
    item_name: itemName,
    new_name: newName,
    path,
    company_id: companyId,
  });
const sendTestMassMessage = ({ subject, body }) =>
  axios.post('/advisors/send_test_mass_message', {
    subject,
    body,
  });
const sendMassMessage = ({ subject, body, clientIds }) =>
  axios.post('/advisors/send_mass_message', {
    subject,
    body,
    client_ids: clientIds,
  });
const sendClientLoginInfo = ({ userIds }) =>
  axios.post('/advisors/send_client_login_info', {
    user_ids: userIds,
  });
const updateAssignments = ({ ids, advisorId, cpaId, clientManagerId }) =>
  axios.post(`/advisors/update_assignments`, {
    ids,
    advisor_id: advisorId,
    cpa_id: cpaId,
    client_manager_id: clientManagerId,
  });
const downloadIndividualImportTemplate = () =>
  axios.post('advisors/download_individual_import_template');
const downloadBusinessImportTemplate = () =>
  axios.post('advisors/download_business_import_template');
const getAllCompanies = () => axios.post('/advisors/get_all_companies');
const getAssignedCompanies = ({ companyId, advisorId }) =>
  axios.post('/advisors/get_assigned_companies', {
    advisor_id: advisorId,
  });
const addAssignment = ({ companyId, advisorId }) =>
  axios.post('/advisors/add_assignment', {
    company_id: companyId,
    advisor_id: advisorId,
  });
const removeAssignment = ({ companyId, advisorId }) =>
  axios.post('/advisors/remove_assignment', {
    company_id: companyId,
    advisor_id: advisorId,
  });
const getTimeBlocks = () => axios.post('/advisors/get_time_blocks');
const saveMyAvailability = params =>
  axios.post('/advisors/save_availability', params);
const updateAdvisor = ({ id, ...rest }) =>
  axios.patch(`/advisors/${id}`, {
    ...rest,
  });
const getAllNotifications = () => axios.get('/advisors/get_all_notifications');
const getAllActivities = () => axios.get('/advisors/get_all_activities');
const getAllConversations = () => axios.get('/advisors/get_all_conversations');
const sendDailyNotification = () =>
  axios.post('/advisors/send_daily_notification');

const dismissNotification = id =>
  axios.get(`/advisors/dismiss_notification/?id=${id}`);

const dismissAllNotificationsOfCompany = company_id =>
  axios.get(
    `/advisors/dismiss_all_notifications_of_company?company_id=${company_id}`,
  );

const dismissAllNotifications = () =>
  axios.get('/advisors/dismiss_all_notifications');

const getAllExportTasks = () => axios.get(`/advisors/get_all_export_tasks`);

const getDocumentBlocks = ({ id }) =>
  axios.post('/advisors/get_document_blocks', {
    id,
  });
const detectDocumentText = ({ data }) =>
  axios.post('/advisors/detect_document_text', {
    data,
  });
const getTotalExtractedDocuments = ({ firmId }) =>
  axios.get(
    '/advisors/get_total_extracted_documents_for_export?' +
      queryString.stringify(
        {
          firm_id: firmId,
        },
        { skipNull: true },
      ),
  );
const getExtractedDocumentsForExport = ({
  page,
  rowsPerPage,
  sortBy,
  descending,
  firmId,
}) =>
  axios.get(
    '/advisors/get_extracted_documents_for_export?' +
      queryString.stringify(
        {
          firm_id: firmId,
          sort_by: sortBy,
          descending: descending,
          page: page,
          rowsPerPage: rowsPerPage,
        },
        { skipNull: true },
      ),
  );

const getAllFirms = () => axios.get('/advisors/get_all_firms');

const getUploadedDocumentLogs = ({ timeRange, ids }) => {
  return axios.get(
    '/advisors/get_uploaded_document_logs?' +
      queryString.stringify({
        time_range: timeRange,
        ids,
      }),
  );
};

const getReminderLogs = ({ timeRange }) => {
  return axios.get(
    '/advisors/get_reminder_logs?' +
      queryString.stringify({
        time_range: timeRange,
      }),
  );
};

const getUpdatedQuestionnaires = ({ timeRange }) => {
  return axios.get(
    '/advisors/get_updated_questionnaires?' +
      queryString.stringify({
        time_range: timeRange,
      }),
  );
};

const getStartedQuestionnaires = ({ timeRange }) => {
  return axios.get(
    '/advisors/get_started_questionnaires?' +
      queryString.stringify({
        time_range: timeRange,
      }),
  );
};

const searchDocs = ({ search, basePath }) =>
  axios.post('/advisors/search_docs', { value: search, basePath: basePath });

const downloadOverviewPageAsSpreadsheet = ({ questionnaireIds }) => {
  return axios.post(`/advisors/download_overview_page_as_spreadsheet`, {
    questionnaire_ids: questionnaireIds,
  });
};

export default {
  getAllExportTasks,
  getTotalExtractedDocuments,
  getAllQuestionnaireYears,
  getExtractedDocumentsForExport,
  getAllCompanies,
  getAssignedCompanies,
  addAssignment,
  removeAssignment,
  getTimeBlocks,
  saveMyAvailability,
  updateAdvisor,
  getAllNotifications,
  getAllActivities,
  dismissNotification,
  dismissAllNotifications,
  dismissAllNotificationsOfCompany,
  getDocuments,
  renameItem,
  getAllConversations,
  downloadIndividualImportTemplate,
  downloadBusinessImportTemplate,
  updateAssignments,
  sendClientLoginInfo,
  sendTestMassMessage,
  sendMassMessage,
  listAllUserEmails,
  getDocumentBlocks,
  detectDocumentText,
  getAllFirms,
  getUploadedDocumentLogs,
  getReminderLogs,
  getStartedQuestionnaires,
  getUpdatedQuestionnaires,
  getToDoList,
  dismissToDoItem,
  getQuestionnaires,
  getComments,
  getMessages,
  searchDocs,
  sendDailyNotification,
  downloadOverviewPageAsSpreadsheet,
};
